import { motion, useReducedMotion } from "framer-motion";
import { Section } from "./Section";
import { LucideIcon } from "@/components/marketing/LucideIcon";
import { EXTENDED } from "@/content/landing";

export function ExtendedFeatures() {
  const reduce = useReducedMotion();
  return (
    <Section
      id="trust-layer"
      testId="landing-extended-features"
      eyebrow={EXTENDED.eyebrow}
      title={EXTENDED.title}
      subtitle={EXTENDED.subtitle}
    >
      <div className="grid grid-cols-1 gap-5 md:grid-cols-6">
        {EXTENDED.cards.map((c, i) => (
          <motion.article
            key={c.title}
            data-testid={`extended-card-${i}`}
            initial={reduce ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, ease: "easeOut", delay: (i % 3) * 0.08 }}
            className={`group relative overflow-hidden rounded-2xl border border-border/60 bg-card/50 p-6 backdrop-blur transition-colors hover:border-sema-mid/50 ${
              c.span === "lg" ? "md:col-span-3" : "md:col-span-2"
            }`}
          >
            <div
              aria-hidden="true"
              className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full opacity-0 blur-2xl transition-opacity duration-500 group-hover:opacity-40"
              style={{ background: "radial-gradient(closest-side, #5B78E5, transparent)" }}
            />
            <div className="relative">
              <span
                className="inline-flex h-11 w-11 items-center justify-center rounded-xl"
                style={{ backgroundColor: "rgba(91,120,229,0.14)", color: "#5B78E5" }}
              >
                <LucideIcon name={c.icon} className="h-5 w-5" />
              </span>
              <h3 className="mt-4 font-display text-lg font-semibold tracking-tight text-foreground">{c.title}</h3>
              <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.16em] text-sema-mid">{c.claim}</p>
              <p className="mt-3 font-body text-sm leading-relaxed text-muted-foreground">{c.body}</p>
              {c.image && (
                <div className="mt-5 overflow-hidden rounded-xl border border-border/60">
                  <img
                    src={c.image}
                    alt={`${c.title} preview`}
                    loading="lazy"
                    className="h-auto w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                  />
                </div>
              )}
            </div>
          </motion.article>
        ))}
      </div>
    </Section>
  );
}
